export default __webpack_public_path__ + "static/media/port2.d46b5509.JPG";